import React from 'react';

import { useQuery } from '@apollo/client/react';
import { useUser } from '@repo/hooks/useUser';
import { useParams } from 'react-router';

import { MainView, NoAccessView } from '@repo/ui/Views';

import MmsOverview from '../components/MmsOverview';

import MMS_REQUEST_SHOW_Q from '../gql/mmsRequest_show.gql';

import { POLICIES } from '@/lib/Authorization';

const Mms = () => {
  const user = useUser();
  const params = useParams();
  const mmsId = params.mmsId;

  const { loading, error, data } = useQuery(MMS_REQUEST_SHOW_Q, {
    variables: {
      id: String(mmsId),
    },
  });

  const view = POLICIES['mms_requests:index'](user) ? (
    <MainView
      title={loading ? `Loading...` : `MMS: ${data?.mmsRequest.id ?? ''}`}
      loading={loading}
    >
      <MmsOverview data={data!} loading={loading} error={error} />
    </MainView>
  ) : (
    <NoAccessView />
  );

  return view;
};

export default Mms;
